import { CommonEntities, SystemAttribute } from "ui-ionic-comp";
import { Organization } from "../organizations/organization.entity";

export interface Draft {
  id: string; // Primary Key
  organizationId: string; // Foreign Key to Organizations table
  teamTypeId: number; // Foreign Key to SystemAttributes table
  statusId: number;
  seasonId: number; // Season
  name: string; // Draft name
  year: number; // Season year
  startDate: string; // Draft start date
  endDate: string; // Draft end date
  startTime: string; // Start time in HH:mm:ss format
  endTime: string; // End time in HH:mm:ss format
  isRepickAllowed: boolean; // Whether repick is allowed
  pickGapDuration: number; // Delay in minutes
  pickWindowDuration: number; // Time frame in minutes

  // Navigation attributes
  organization?: Organization;
  teamType?: SystemAttribute;
  status?: SystemAttribute;
  season?: SystemAttribute;
}

export interface DraftUpdateRequest {
  teamTypeId?: number; // Foreign Key to SystemAttributes table
  statusId?: number;
  seasonId?: number; // Season
  name?: string; // Draft name
  year?: number; // Season year
  startDate?: string; // Draft start date
  endDate?: string; // Draft end date
  startTime?: string; // Start time in HH:mm:ss format
  endTime?: string; // End time in HH:mm:ss format
  isRepickAllowed?: boolean; // Whether repick is allowed
  pickGapDuration?: number; // Delay in minutes
  pickWindowDuration?: number; // Time frame in minutes
}

export type DraftsReponse = CommonEntities<Draft>;

export const DraftTypes = {
  Parent: 'DRAFT_TYPES',
  Children: {
  },
};

export const DraftStatuses = {
  Parent: 'DRAFT_STATUSES',
  Children: {
  },
};

export const DraftSeasons = {
  Parent: 'SEASONS',
  Children: {
  },
};

export const TeamGenders = {
  Parent: 'TEAM_GENDERS',
  Children: {
  },
};

export const VisibilityGroups = {
  Parent: 'VISIBILITY_GROUPS',
  Children: {
  },
};

export enum DraftStatus {
  Setup = 'DRAFT_STATUS_SETUP',
  TimeWindow = 'DRAFT_STATUS_TIME_WINDOW',
  Launched = 'DRAFT_STATUS_LAUNCHED',
  End = 'DRAFT_STATUS_END'
}

export enum VisibilityGroup {
  GroupA = 'VISIBILITY_GROUP_A',
  GroupB = 'VISIBILITY_GROUP_B',
  GroupC = 'VISIBILITY_GROUP_C',
  GroupD = 'VISIBILITY_GROUP_D'
}

